import { MapPin } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { Kicker, Reveal } from "@/components/Reveal";
import { ChittaGraphic } from "@/components/ChittaGraphic";

export const Institute = () => {
    const { t } = useSite();
    return (
        <section id="institute" data-testid="institute-section" className="theme-fade relative overflow-hidden mesh-light">
            <div className="mx-auto grid max-w-[1440px] grid-cols-1 gap-14 px-5 py-24 sm:px-8 sm:py-32 lg:grid-cols-12 lg:gap-12 lg:px-12 lg:py-40">
                <div className="lg:col-span-7">
                    <Reveal>
                        <Kicker>{t.institute.kicker}</Kicker>
                        <h2 className="headline-section mt-6 max-w-[16ch] font-display font-semibold text-theme-ink" data-testid="institute-name">
                            {t.institute.name}
                        </h2>
                        <span
                            data-testid="institute-status"
                            className="mt-8 inline-flex items-center gap-2 border border-theme-strong px-4 py-2 font-display text-xs font-semibold uppercase tracking-[0.22em] text-sky-ink"
                        >
                            <span aria-hidden="true" className="h-2 w-2 bg-chitta-yellow" />
                            {t.institute.status}
                        </span>
                        <p className="mt-8 max-w-[48ch] text-base leading-[1.85] text-theme-muted sm:text-lg" data-testid="institute-desc">
                            {t.institute.desc}
                        </p>
                        <p className="mt-10 flex items-start gap-3 font-body text-sm font-semibold tracking-wide text-theme-ink" data-testid="institute-address">
                            <MapPin size={18} className="mt-0.5 shrink-0 text-sky-ink" aria-hidden="true" />
                            <span>
                                <span className="mb-1 block font-display text-[11px] font-medium uppercase tracking-[0.24em] text-theme-muted">
                                    {t.institute.addressLabel}
                                </span>
                                {t.institute.address}
                            </span>
                        </p>
                    </Reveal>
                </div>
                <div className="relative lg:col-span-5">
                    <Reveal delay={0.15} className="h-full">
                        <div className="duotone h-full overflow-hidden rounded-2xl">
                            <img
                                src={t.institute.img}
                                alt={t.institute.alt}
                                loading="lazy"
                                width="1600"
                                height="1067"
                                className="h-full min-h-[320px] w-full object-cover"
                            />
                        </div>
                    </Reveal>
                </div>
            </div>
            <ChittaGraphic className="pointer-events-none absolute bottom-0 left-0 w-40 opacity-70 sm:w-56" />
        </section>
    );
};
